import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

const EditBannerModal = ({ show, handleClose, banner, handleSave }) => {
    const [nickname, setNickname] = useState('');
    const [image, setImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [changedFields, setChangedFields] = useState({});
    const [projectId, setProjectId] = useState('');

    useEffect(() => {
        if (banner) {
            setNickname(banner.nickname);
            setPreviewImage(banner.image_path);
            setProjectId(banner.project_id || ''); // Handle potential null value
        }
    }, [banner]);

    const handleNicknameChange = (e) => {
        const newValue = e.target.value;
        setNickname(newValue);
        setChangedFields({ ...changedFields, nickname: newValue });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
                setPreviewImage(reader.result);
                setChangedFields({ ...changedFields, image: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleProjectIdChange = (e) => {
        const newValue = e.target.value;
        setProjectId(newValue);
        setChangedFields({ ...changedFields, project_id: newValue });
    };

    const handleSaveClick = async () => {
        try {
            const response = await api.put(`/banners/${banner.id}`, changedFields);
            if (response.data && response.data.response) {
                handleSave(response.data.response.data);
                toast.success('Banner updated successfully');
            } else {
                toast.error('Failed to update banner');
            }
            setChangedFields({});
        } catch (error) {
            console.error('Error updating banner:', error);
            toast.error('An error occurred while updating the banner.');
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Banner</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="projectId">
                        <Form.Label>Project ID</Form.Label>
                        <Form.Control
                            type="number"
                            value={projectId}
                            onChange={handleProjectIdChange}
                            placeholder="Enter Project ID (optional)"
                        />
                    </Form.Group>
                    <Form.Group controlId="nickname">
                        <Form.Label>Nickname</Form.Label>
                        <Form.Control
                            type="text"
                            value={nickname}
                            onChange={handleNicknameChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="image">
                        <Form.Label>Image</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                    </Form.Group>
                    {previewImage && (
                        <div className="mt-3">
                            <img
                                src={previewImage}
                                alt="Banner Preview"
                                style={{ maxWidth: '100%', maxHeight: '200px' }}
                            />
                        </div>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSaveClick}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditBannerModal;